import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Removes a listener previously added with `}<inlineCode parentName="p">{`addListener`}</inlineCode>{`. You should pass as parameters the exact same parameters passed to `}<inlineCode parentName="p">{`addListener`}</inlineCode>{`.`}</p>
    <p>{`Alternatively, you can just use the function returned by `}<inlineCode parentName="p">{`addListener`}</inlineCode>{`.`}</p>
    <p>{`Note: if you try to add a listener for an event that can't be handled, `}<inlineCode parentName="p">{`addListener`}</inlineCode>{` will not add it and it will return `}<inlineCode parentName="p">{`undefined`}</inlineCode>{` instead of a function to remove it.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      